import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  { q: "How long does a full Shopify redesign take?", a: "Our standard timeline is 21–35 days, depending on store complexity. We work in tight sprints with weekly previews so you're never in the dark." },
  { q: "Do you handle both Meta and Google Ads?", a: "Yes. We run integrated paid acquisition across Meta, Google (Search/Shopping/PMax), TikTok, and more. Strategy, creative, and reporting are all in-house." },
  { q: "What's your pricing model?", a: "We offer fixed-fee project work (design/redesign), monthly retainers (ads + CRO), and performance-based hybrid agreements for established brands. Schedule a call for a custom quote." },
  { q: "What is your CRO process?", a: "Hypothesis → research (heatmaps, session recordings, data audit) → A/B test design → implementation → analysis. Every test is documented and tied to revenue." },
  { q: "Do you only work with Shopify brands?", a: "Yes — we specialize in Shopify and Shopify Plus. This focus is what allows us to deliver category-leading results." },
  { q: "What size brands do you typically work with?", a: "Our sweet spot is brands doing $50K–$5M/month in revenue, looking to break their next plateau. We also support emerging brands ready to scale." },
  { q: "How do you measure success?", a: "Revenue, ROAS, CVR, AOV, LTV, and contribution margin. You'll get a live dashboard plus weekly written reports with action items." },
];

export default function FAQ() {
  return (
    <section data-testid="faq-section" className="relative py-24 md:py-32 bg-[#070709] border-y border-white/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.25em] text-blue-400 font-bold">Frequently Asked</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-[1.05]">
            Questions, <span className="text-gradient">answered.</span>
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/5 bg-[#0A0A0C] rounded-2xl px-6 data-[state=open]:border-blue-500/25 transition"
            >
              <AccordionTrigger className="text-left font-display text-base md:text-lg font-bold text-white hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
